{
    "titleinformation": "Recipient Holder Information",
    "titleaddress": "Recipient Holder Address",
    "input":{
        "profiletype": "Recipient Type",
        "name": "Recipient Holder Name",
        "addressline1": "Address Line 1",
        "addressline2": "Address Line 2",
        "addressline3": "Address Line 3",
        "city": "City",
        "state": "State",
        "postalcode": "Postal Code",
        "country": "Country",
        "unitnumber": "Unit Number",
        "tin": "Tax Reference Number",
        "relationshiptocustomer": "Relationship to Customer",
        "phone": "Telephone Number",
        "lineofbusiness": "Line of Business",
        "email": "E-mail Address"
    },
    "crypto": {
        "profile": {
            "name": "Recipient Holder Name",
            "profileType": "Recipient Type",
            "country": "Country",
            "relationshiptocustomer": "Relationship to Customer"
        }
    }
}